"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EntityDuplicateDialog = exports.EntityDuplicateDialogDefaultProps = void 0;
var react_1 = __importStar(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var dialog_1 = require("../elements/dialog");
var icon_button_1 = require("../elements/icon-button");
var use_entity_definition_named_1 = require("../../hooks/use-entity-definition-named");
var use_icons_1 = require("../../hooks/use-icons");
var use_lang_1 = require("../../hooks/use-lang");
var sprintf_js_1 = require("sprintf-js");
var entity_duplicate_layout_1 = require("./entity-duplicate-layout");
exports.EntityDuplicateDialogDefaultProps = {
  variant: 'default',
  onContinue: function () {},
  onCancel: function () {}
};
// -------- Styles -------->
var DialogStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    text-align: left;\n  "], ["\n    text-align: left;\n  "])))
});
var ControlsStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    display: flex;\n    justify-content: space-between;\n    padding: ", " ", " ", " ;\n    background: ", ";\n    border-top: 1px solid ", ";\n  "], ["\n    display: flex;\n    justify-content: space-between;\n    padding: ", " ", " ", " ;\n    background: ", ";\n    border-top: 1px solid ", ";\n  "])), theme_1.theme.UNIT(4.5), theme_1.theme.UNIT(5), theme_1.theme.UNIT(5), theme_1.theme.COLOR('form-header'), theme_1.theme.COLOR('line-subtle'))
});
var CancelButtonStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var ContinueButtonStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var LinkButtonStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  "], ["\n  "])))
});
// const BodyStyles = breakpoints({
//   base: css`
//     background-color: ${theme.COLOR('app-chrome')};
//     padding: ${theme.UNIT(5)};
//     font-size: ${theme.FONT_SIZE(15)};
//     line-height: ${24/14}em;
//     border-top: 1px solid ${theme.COLOR('line-subtle')};
//     display: flex;
//     flex-direction: column;
//     align-items: left;
//     text-align: left;
//   `,
// });
// const InfoStyles = breakpoints({
//   base: css`
//     margin-top: 0;
//   `,
// });
// const QuestionStyles = breakpoints({
//   base: css`
//     margin-top: 0;
//   `,
// });
// const IndicatorStyles = breakpoints({
//   base: css`
//     opacity: 0.1;
//     align-self: center;
//   `,
// });
// const ItemsStyles = breakpoints({
//   base: css`
//     width: 100%;
//     margin: 0;
//     list-style-type: none;
//     padding: 0;
//   `,
// });
// type ItemProps = {
//   linked: boolean;
// };
// const ItemStyles = breakpoints({
//   base: css`
//     margin: 0;
//     text-align: left;
//     box-sizing: border-box;
//     border-top: 1px solid ${theme.COLOR('line-subtle')};
//     padding: ${theme.UNIT(4.5)} ${theme.UNIT(5)};
//     background: ${theme.COLOR('light')};
//     width: 100%;
//     ${({ linked }: ItemProps) => linked && css`
//       cursor: pointer;
//       transition: transform 0.3s;
//       &:hover {
//         transform: scale(1.02, 1.02);
//       }
//     `}
//   `,
// });
// const EntityStyles = breakpoints({
//   base: css`
//   `,
// });
var DuplicateLayoutStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
// -------- Components -------->
var My = {
  Dialog: (0, styled_components_1.default)(dialog_1.Dialog)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), DialogStyles),
  Controls: styled_components_1.default.div(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), ControlsStyles),
  CancelButton: (0, styled_components_1.default)(icon_button_1.CloseIconButton)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["", ""], ["", ""])), CancelButtonStyles),
  ContinueButton: (0, styled_components_1.default)(icon_button_1.ContinueIconButton)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", ""], ["", ""])), ContinueButtonStyles),
  LinkButton: (0, styled_components_1.default)(icon_button_1.IconButton)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["", ""], ["", ""])), LinkButtonStyles),
  DuplicateLayout: (0, styled_components_1.default)(entity_duplicate_layout_1.EntityDuplicateLayout)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["", ""], ["", ""])), DuplicateLayoutStyles)
};
var EntityDuplicateDialog = function (props) {
  var className = props.className,
    entityTypeName = props.entityTypeName,
    items = props.items,
    name = props.name,
    variant = props.variant,
    onLink = props.onLink,
    onCancel = props.onCancel,
    onContinue = props.onContinue;
  var definition = (0, use_entity_definition_named_1.useEntityDefinitionNamed)(entityTypeName);
  var config = definition.duplicateDialogConfig;
  var t = (0, use_lang_1.useLang)();
  var icons = (0, use_icons_1.useIcons)();
  var strings = (0, react_1.useMemo)(function () {
    return {
      continueLabel: (0, sprintf_js_1.sprintf)(t(config.continueLabel), definition.label),
      cancelLabel: (0, sprintf_js_1.sprintf)(t(config.cancelLabel), definition.label),
      title: (0, sprintf_js_1.sprintf)(t(config.title), definition.label),
      linkLabel: (0, sprintf_js_1.sprintf)(t(config.linkLabel), definition.label)
    };
  }, [entityTypeName, name, variant]);
  return react_1.default.createElement(My.Dialog, {
    padBody: false,
    title: strings.title,
    className: className,
    controls: react_1.default.createElement(My.Controls, null, react_1.default.createElement(My.ContinueButton, {
      onClick: onContinue
    }, strings.continueLabel), variant === 'default' && react_1.default.createElement(My.CancelButton, {
      onClick: onCancel
    }, strings.cancelLabel), variant === 'linked' && react_1.default.createElement(My.LinkButton, {
      icon: react_1.default.createElement(icons.Entities.Link, null)
    }, strings.linkLabel))
  }, react_1.default.createElement(My.DuplicateLayout, {
    name: name,
    entityTypeName: entityTypeName,
    items: items,
    variant: variant,
    onLink: onLink
  }));
};
exports.EntityDuplicateDialog = EntityDuplicateDialog;
exports.EntityDuplicateDialog.defaultProps = exports.EntityDuplicateDialogDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12;